import { IAppContextActions } from 'contexts/App/types'
import { json } from 'services/RequestService'
import { IBaseResponse } from 'services/RequestService/Response'
import { ContentGroupListSchema } from './types'

const s123FalaUrl = process.env.REACT_APP_123FALA_URL

export const GetContentGroupList = async (
  bot_name: string,
  dispatch: React.Dispatch<IAppContextActions>,
): Promise<IBaseResponse<ContentGroupListSchema[]>> => {
  const action = `/${bot_name}/content-groups`
  const token = localStorage.getItem('@studio:user_access_token')

  return json<ContentGroupListSchema[]>(
    'GET',
    action,
    dispatch,
    undefined,
    undefined,
    {
      baseUrl: s123FalaUrl,
      customRequestInit: {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    },
  )
}
